export default "__VITE_ASSET__245f1b32__"